import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {
  if (id) return `/v1/companies/${auth.getCurrentUser().company_id}/rooms/${id}`;
  else return `/v1/companies/${auth.getCurrentUser().company_id}/rooms`;
}

export function getAll() {
  return http.get(supplierStoreUrl());
}

export function deleteSingle(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function updateSingle(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

export function updateSingleStatus(supplier) {
  return http.get(
    `/v1/companies/${auth.getCurrentUser().company_id}/rooms/${supplier.id}/status`
  );
}

export function getSingle(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}

export function getSingleRoom(supplierId, companyId) {
  return http.get(`/v1/companies/${companyId}/rooms/${supplierId}`);
}

export function getAccountCompany(accountId) {
  return http.get(`/v1/get-company/room/${accountId}`);
}

export function getLedgerAccountCompany(accountId) {
  return http.get(`/v1/get-ledger-account-company/room/${accountId}`);
}

